import type { Action } from "@core/features/actions";
import { ProgramPhaseActionItem } from "./ProgramPhaseActionItem";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";

type Props = {
  action: Action;
  disabled: boolean;
  /** When true, always use the compact (mobile) layout */
  compact?: boolean;
};

export function ProgramPhaseActionItemContainer({ action, disabled, compact }: Props) {
  const userTimezoneOption = useUserTimezoneOption();

  if (!userTimezoneOption) {
    return null;
  }

  return (
    <ProgramPhaseActionItem
      action={action}
      disabled={disabled}
      userTimezoneOption={userTimezoneOption}
      compact={compact}
    />
  );
}

export default ProgramPhaseActionItemContainer;

